import { DateRange } from './date';
export class Comments {
type: string;
referenceId: number;
comments: string;
  createdBy: number;
  createdDate: string;
}

export class CommentSearch {
    createdDate: DateRange = DateRange.empty();
    todayDate: DateRange = DateRange.today();
    filename = '';
    id = '';
    title = '';
    type = '';
    referenceId = '';
 }
